export const oswestryEn = {
  promInstructions:
    "Please choose the option that most closely describes how your back pain affects your present day situation.",
  questions: [
    {
      scaleStartLabel: "No Pain",
      scaleEndLabel: "Extreme Pain",
      scaleLabels: [
        "I can tolerate the pain I have without having to use pain medication",
        "The pain is bad, but I can manage without having to take pain medication",
        "Pain medication provides me with complete relief from pain",
        "Pain medication provides me with moderate relief from pain",
        "Pain medication provides me with little relief from pain",
        "Pain medication has no effect on my pain",
      ],
      text: "Can you describe your pain intensity?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can take care of myself normally without causing increased pain",
        "I can take care of myself normally, but it increases my pain",
        "It is painful to take care of myself, and I am slow and careful",
        "I need help, but I am able to manage most of my personal care",
        "I need help every day in most aspects of my care",
        "I do not get dressed. I wash with difficulty and I stay in bed",
      ],
      text: "Can you describe how your back symptoms affect your personal care?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can lift heavy weights without increased pain",
        "I can lift heavy weights, but it causes increased pain",
        "Pain prevents me from lifting heavy weights off the floor, but I can manage if the weights are conveniently positioned, i.e., on a table",
        "Pain prevents me from lifting heavy weights, but I can manage light to medium weights if they are conveniently positioned",
        "I can lift only very light weights",
        "I cannot lift or carry anything at all",
      ],
      text: "Can you describe how your back symptoms affect your ability to lift weights?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "Pain does not prevent me from walking any distance",
        "Pain prevents me from walking more than 1 mile",
        "Pain prevents me from walking more than ½ mile",
        "Pain prevents me from walking more than ¼ mile",
        "I can walk only with crutches or a cane",
        "I am in bed most of the time and have to crawl to the toilet",
      ],
      text: "Can you describe how your back symptoms affect your ability to walk?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can sit in any chair as long as I like",
        "I can only sit in my favorite chair as long as I like",
        "Pain prevents me from sitting for more than 1 hour",
        "Pain prevents me from sitting for more than ½ hour",
        "Pain prevents me from sitting for more than 10 minutes",
        "Pain prevents me from sitting at all",
      ],
      text: "Can you describe how your back symptoms affect your ability to sit?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can stand as long as I want without increased pain",
        "I can stand as long as I want, but it increases my pain",
        "Pain prevents me from standing for more than 1 hour",
        "Pain prevents me from standing for more than ½ hour",
        "Pain prevents me from standing for more than 10 minutes",
        "Pain prevents me from standing at all",
      ],
      text: "Can you describe how your back symptoms affect your ability to stand?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "Pain does not prevent me from sleeping well",
        "I can sleep well only by using pain medication",
        "Even when I take medication, I sleep less than 6 hours",
        "Even when I take medication, I sleep less than 4 hours",
        "Even when I take medication, I sleep less than 2 hours",
        "Pain prevents me from sleeping at all",
      ],
      text: "Can you describe how your back symptoms affect your ability to sleep?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "My social life is normal and does not increase my pain",
        "My social life is normal, but it increases my level of pain",
        "Pain prevents me from participating in more energetic activities (e.g., sports, dancing)",
        "Pain prevents me from going out very often",
        "Pain has restricted my social life to my home",
        "I have hardly any social life because of my pain",
      ],
      text: "Can you describe how your back symptoms affect your social life?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can travel anywhere without increased pain",
        "I can travel anywhere, but it increases my pain",
        "My pain restricts my travel over 2 hours",
        "My pain restricts my travel over 1 hour",
        "My pain restricts my travel to short necessary journeys under ½ hour",
        "My pain prevents all travel except for visits to the physician/therapist or hospital",
      ],
      text: "Can you describe how your back symptoms affect your ability to travel?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "My normal homemaking / job activities do not cause pain",
        "My normal homemaking / job activities increase my pain, but I can still perform all that is required of me",
        "I can perform most of my homemaking / job duties, but pain prevents me from performing more physically stressful activities (e.g., lifting, vacuuming)",
        "Pain prevents me from doing anything but light duties",
        "Pain prevents me from doing even light duties",
        "Pain prevents me from performing any job or homemaking chores",
      ],
      text: "Can you describe how your back symptoms affect your employment and homemaking duties?",
    },
  ],
};
